export default __webpack_public_path__ + "static/media/Shared-Image-ARTIGOS-SYS-01_EN-06.5581e4b9.jpg";